export const LOGGING_ENABLED = process.env.LOGGING_ENABLED === 'true';
export const IS_CLIENT = typeof window !== 'undefined';
export const CYPRESS_DEFINED = typeof Cypress !== 'undefined';
export const JEST_DEFINED = typeof jest !== 'undefined';
export const IS_PREVIEW =
  process.env.CF_PAGES && process.env.APP_ENV !== 'production';
export const IS_PRODUCTION =
  process.env.CF_PAGES && process.env.APP_ENV === 'production';
export const IS_BUILD_OR_TEST = CYPRESS_DEFINED || !IS_CLIENT || JEST_DEFINED;
